export default defineNuxtPlugin(() => {
  // Suppress Suspense experimental feature warnings and Vue Router OAuth hash warnings
  if (process.client) {
    const nuxtApp = useNuxtApp()
    const originalWarn = console.warn
    const originalError = console.error

    // Filter Vue runtime warnings as early as possible in the app lifecycle.
    const previousWarnHandler = nuxtApp.vueApp.config.warnHandler
    nuxtApp.vueApp.config.warnHandler = (msg, instance, trace) => {
      if (typeof msg === 'string' && (msg.includes('Suspense') || msg.includes('experimental feature'))) {
        return
      }
      if (typeof msg === 'string' && msg.includes('No match found for location with path')) {
        return
      }
      if (previousWarnHandler) {
        previousWarnHandler(msg, instance, trace)
        return
      }
      originalWarn(msg, trace || '')
    }
    
    console.warn = (...args) => {
      // Filter out Suspense experimental warnings
      if (args[0] && typeof args[0] === 'string' && args[0].includes('Suspense')) {
        return
      }
      // Filter out other experimental feature warnings
      if (args[0] && typeof args[0] === 'string' && args[0].includes('experimental feature')) {
        return
      }
      // Filter out runtime-core warnings
      if (args[0] && typeof args[0] === 'string' && args[0].includes('runtime-core')) {
        return
      }
      // Filter out Vue Router warnings about invalid selectors (OAuth hash)
      if (args[0] && typeof args[0] === 'string' && 
          (args[0].includes('Vue Router warn') || args[0].includes('[Vue Router warn]')) &&
          (args[0].includes('selector') || args[0].includes('access_token=') || args[0].includes('invalid'))) {
        return
      }
      // Filter out Vue Router "No match found" warnings in dev console.
      if (args[0] && typeof args[0] === 'string' &&
          (args[0].includes('Vue Router warn') || args[0].includes('[Vue Router warn]')) &&
          args[0].includes('No match found for location with path')) {
        return
      }
      // Filter out Nuxt warning about NuxtPage / RouterView (we use NuxtPage in app.vue)
      if (args[0] && typeof args[0] === 'string' && args[0].includes('NuxtPage') && args[0].includes('RouterView')) {
        return
      }
      // Allow other warnings through
      originalWarn.apply(console, args)
    }

    console.error = (...args) => {
      // Filter out Suspense experimental warnings in error messages too
      if (args[0] && typeof args[0] === 'string' && args[0].includes('Suspense')) {
        return
      }
      // Filter out experimental feature warnings in error messages
      if (args[0] && typeof args[0] === 'string' && args[0].includes('experimental feature')) {
        return
      }
      // Filter out Vue Router warnings about invalid selectors (OAuth hash)
      if (args[0] && typeof args[0] === 'string' && 
          (args[0].includes('Vue Router warn') || args[0].includes('[Vue Router warn]')) &&
          (args[0].includes('selector') || args[0].includes('access_token=') || args[0].includes('invalid'))) {
        return
      }
      if (args[0] && typeof args[0] === 'string' &&
          (args[0].includes('Vue Router warn') || args[0].includes('[Vue Router warn]')) &&
          args[0].includes('No match found for location with path')) {
        return
      }
      // Allow other errors through
      originalError.apply(console, args)
    }
  }
})
